/**
 * Shared vocabulary for the attendance screens — the status/source colours and the tiny formatters
 * the list table and the record modal both speak. It lives outside `AttendancePage` so the two can
 * import it without importing each other (a cycle), and so a status can never mean green in the
 * table and grey in the modal.
 */

export const STATUS_OPTIONS = ['PRESENT', 'HALF_DAY', 'LEAVE', 'ABSENT', 'HOLIDAY'];

export const STATUS_COLOR: Record<string, 'green' | 'gold' | 'blue' | 'red' | 'neutral'> = {
  PRESENT: 'green', HALF_DAY: 'gold', LEAVE: 'blue', ABSENT: 'red', HOLIDAY: 'neutral',
};

// How the record was created (SELF needs no chip in the table — the modal spells it out instead).
export const SOURCE_TAG: Record<string, { text: string; color: 'purple' | 'blue' | 'gold' }> = {
  REGULARIZED: { text: 'Regularized', color: 'purple' },
  MANUAL: { text: 'Manual', color: 'blue' },
  ON_BEHALF: { text: 'On behalf', color: 'purple' },
  AUTO: { text: 'Auto checkout', color: 'gold' },
};

/** Compact minutes → "5h 50m" for the auto-checkout idle badge. */
export const fmtIdle = (m?: number | null) => (m == null ? '' : m < 60 ? `${m}m` : `${Math.floor(m / 60)}h ${m % 60}m`);

export const mapsUrl = (lat?: string | null, lng?: string | null) =>
  lat && lng ? `https://www.google.com/maps?q=${lat},${lng}` : undefined;

export const fmtWorked = (min?: number | null) =>
  min == null ? '—' : `${Math.floor(min / 60)}h ${min % 60}m`;

/** True when the row belongs to a Sales Head (the role label is the only role signal on a log row). */
export const isHeadRole = (role?: string | null) => /head/i.test(String(role ?? ''));
